import React, { useCallback, useEffect, useState } from 'react';
import { Autocomplete, AutocompleteProps } from '@material-ui/lab';
import { AxiosRequestConfig } from 'axios';
import instance, { PPR_API_URL } from 'api';
import useDebounce from 'hooks/useDebounce';
import { IEquipment } from '../interfaces';

const getEquipmentList = (config: AxiosRequestConfig) => {
  return instance(true, PPR_API_URL)
    .get<IEquipment[]>('/dictionary/equipment/listByEquipmentType', config)
    .then((response) => response.data);
};

function SearchEquipments<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  ...props
}: { config?: AxiosRequestConfig } & Omit<
  AutocompleteProps<IEquipment, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const [query, setQuery] = useState('');
  const [data, setData] = useState<IEquipment[]>([]);
  const [loading, setLoading] = useState(false);
  const debouncedValue = useDebounce<string>(query, 1000);

  const handleSearch = useCallback((value: string) => {
    setQuery(value);
  }, []);

  useEffect(() => {
    if (!debouncedValue.length) setData([]);
    if (debouncedValue.length < 1) return;

    setLoading(true);
    getEquipmentList({ ...config, params: { ...config?.params, find: debouncedValue } })
      .then((response) => setData(response))
      .finally(() => setLoading(false));
  }, [debouncedValue]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Autocomplete
      options={data}
      loading={loading}
      loadingText="Загрузка..."
      noOptionsText="Пусто"
      getOptionSelected={(option, value) => option.equipmentId === value.equipmentId}
      onInputChange={(event, value, reason) => reason === 'input' && handleSearch(value)}
      {...props}
    />
  );
}

export default SearchEquipments;
